import axios from "axios";
import base_url from "../../constants";

// const API_BASE_URL = "http://api.virtualprachar.com/api";

const API_BASE_URL = base_url;
const ApiEndPoints = {
    uploadAndShare: (inputFields) =>
        axios.post(`${API_BASE_URL}/template/upload`, inputFields),

    templatesType1: (data) =>
        axios.get(`${API_BASE_URL}/template/all-details`, data),
    login: (inputFields) => {
        return axios.post(`${API_BASE_URL}/login/username`, inputFields);
    },
    googleLogin: (credential) => {
        return axios.post(`${API_BASE_URL}/login/google`, { credential });
    },
    register: (inputFields) => {
        return axios.post(`${API_BASE_URL}/register/username`, inputFields);
    },
};
export default ApiEndPoints;
